class Queue {
  #data = [];
  enqueue(x) {
    this.#data.push(x);
  }
  dequeue(id) {
    return this.#data.splice(id, 1);
  }
  get size() {
    return this.#data.length;
  }
  get data() {
    return this.#data;
  }
}
export const sharedQueue = new Queue();
